import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import AllVendor from '../../component/allvendor/AllVendor'
import UserHeader from '../../component/reusable/UserHeader';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import Cards from '../../component/reusable/Cards';
import AllWizardEnqTable from '../../component/wizardComps/AllWizardEnqTable';
import ToolCards from '../../component/reusable/ToolCards';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import BomTab from '../../component/bomComps/BomTab';
import AllBomEnqTable from '../../component/bomComps/AllBomEnqTable';
import { deletewizardThunk, exportwizardThunk, getAllwizardThunk, getwizardStatisticsThunk, setwizardFromDate, setwizardPage, setwizardSearch, setwizardSelectedTab, setwizardToDate } from '../../redux/wizardSlice';
import BomFilter from '../../component/bomComps/BomFilter';
import BomStatistics from '../../component/bomComps/BomStatistics';



function WizardEnquires() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('desc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);


    // //delete
    const deleteCategory = () => {
        dispatch(deletewizardThunk(selectedId))
        setIsModalOpen(false);
    }


    // //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };

    const handleChange = (event, newValue) => {
        dispatch(setwizardSelectedTab(newValue))
        setAllStatus('')
        dispatch(setwizardPage(1))
        dispatch(setwizardSearch(''))
        dispatch(setwizardFromDate(''))
        dispatch(setwizardToDate(''))
    };

    const { wizardenquiry, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, wizardenquiryStatistics } = useSelector((state) => state.wizard);
    const wizardData = wizardenquiry?.data
    const totalPages = wizardenquiry?.totalPages
    const totalItems = wizardenquiry?.totalItems
    const itemsPerPage = wizardenquiry?.limit

    const start = (page - 1) * itemsPerPage + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * itemsPerPage + itemsPerPage;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'QUOTED' : selectedTab === 3 ? 'COMPLETED' : "DELETED"

    // console.log(bom);
    useEffect(() => {
        dispatch(getwizardStatisticsThunk())
    }, [])

    useEffect(() => {
        dispatch(getAllwizardThunk(`?search=${search}&page=${page}&limit=${limit}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);

    useEffect(() => {
        if (totalPages && page > totalPages) {
            dispatch(setwizardPage(1));
        }
    }, [dispatch, page, totalPages]);


    const handleSort = (sort, nextOrder) => {
        setSortyBy(sort)
        setOrder(nextOrder)
        dispatch(setwizardPage(1))
    };

    const handleStatusFilter = (nextStatus) => {
        setAllStatus(nextStatus)
        dispatch(setwizardPage(1))
    }

    const exportbomenq = async () => {
        const status = await dispatch(exportwizardThunk(`?limit=${100000}`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',

                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "wizard")
        }
    }




    return (
        <>
            <UserHeader
                index="Wizard Enquiries"
                root="Dashboard"
                exportData={exportbomenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />
            <BomStatistics
                statistics={wizardenquiryStatistics}
            />
            <Box>
                <BomTab handleChange={handleChange} selectedTab={selectedTab} />
                <BomFilter
                    setAllStatus={setAllStatus}
                    search={search}
                    setSearch={setwizardSearch}
                    setFromDate={setwizardFromDate}
                    setToDate={setwizardToDate}
                    selectedTab={selectedTab}
                    onFilterChange={() => dispatch(setwizardPage(1))}
                />
                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {wizardData?.length > 0 ?
                                    <Typography>
                                        <AllBomEnqTable
                                            bomData={wizardData}
                                            page={page}
                                            setPage={setwizardPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            onSort={handleSort}
                                            onStatusFilter={handleStatusFilter}
                                            sortBy={sortBy}
                                            order={order}
                                            selectedTab={selectedTab}
                                            enquiryType={"Wizard"}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/wizard/wizardEnquiresDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default WizardEnquires;
